import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

export const PrimljenePorukeDataTable = (props) => {
  const [poruke, setPoruke] = useState();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  let navigate = useNavigate();

  useEffect(() => {
    setPoruke(props.data);
  }, [props.data]);

  const onCustomPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 25, value: 25 },
        { label: 50, value: 50 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Zapisa po stranici:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };

  const handlePregledajPoruku = async(poruka) => {
    if (poruka.vrijeme_citanja === null){
      const porukaData = { 
        idProcitanePoruke: poruka.id,
        vrijemeCitanja: format(new Date(), 'dd.MM.yyyy. HH:mm:ss.SSSX')
      };

      const headers = { 
      'Authorization': sessionStorage.getItem("token"),
      'Content-Type': 'application/json'
      };
      await axios.post( props.rest + sessionStorage.getItem("ustanova"), JSON.stringify(porukaData), { headers });
    }
    navigate('/pregled_poruke',{ state: { id: poruka.id,
                                          vrijeme_slanja: poruka.vrijeme_slanja,
                                          vrijeme_odgovora: poruka.vrijeme_odgovora,
                                          naslov: poruka.naslov,
                                          tekst_poruke: poruka.tekst_poruke, 
                                          posiljatelj: poruka.predavac,
                                          id_predavaca: poruka.id_predavaca }} );

  }

  const pregledajPoruku = (poruka) => {
      return <Button className={"pi"} disabled={false} label="Pregledaj" onClick={ () => { handlePregledajPoruku(poruka)} }/>;
  }

  const vrijemeSlanjaColumn = (poruka) => {
    if ( poruka.vrijeme_slanja !== null )
      return format(new Date(poruka.vrijeme_slanja), 'dd.MM.yyyy. HH:mm');
    else 
      return "";
  }

  const vrijemeOdgovoraColumn = (poruka) => {
    if ( poruka.vrijeme_odgovora !== null )
      return format(new Date(poruka.vrijeme_odgovora), 'dd.MM.yyyy. HH:mm');
    else 
      return "";
  }
  
  return (
    <div className="centerText">   
      <DataTable
        value={poruke}
        stripedRows
        responsiveLayout="scroll"
        paginator
        paginatorTemplate={paginatorTemplate}
        first={first}
        rows={rows}
        onPage={onCustomPage}
        paginatorClassName="justify-content-end"
      >
      <Column
        field="predavac"
        header="Pošiljatelj"
        className="table-column-grade"
      ></Column>
      <Column
        field="naslov"
        header="Naslov"
        className="table-column-course"
      ></Column>
      <Column
        field="tekst_poruke"
        header="Sadržaj"
        className="table-column-default"
      ></Column>
      <Column
          field="vrijeme_slanja"
          header="Primljeno"
          body = { vrijemeSlanjaColumn }
          className="table-column-date"
        ></Column>
      <Column
        field="vrijeme_odgovora"
        header="Odgovoreno"
        body = { vrijemeOdgovoraColumn }
        className="table-column-date"
      ></Column>
      {/*<Column
        body={ procitajPorukuColumn }
        className="table-column-date"
  ></Column>*/}
      <Column
        header="Pregledaj"
        body={ pregledajPoruku }
        className="table-column-date"
      ></Column>
      </DataTable>
    </div>
  );
};

export default PrimljenePorukeDataTable;
